import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { WhatsAppButton } from './WhatsAppButton';
import { SocialSidebar } from './SocialSidebar';

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col noise-overlay">
      <Navbar />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      <WhatsAppButton />
      <SocialSidebar />
    </div>
  );
};

export default Layout;
